import { SVGProps } from "react";

export default function EngagementIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, stroke = "#545454", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.125 2.5V11.875C3.125 12.9105 3.96447 13.75 5 13.75H6.875M3.125 2.5H1.875M3.125 2.5H16.875M16.875 2.5H18.125M16.875 2.5V11.875C16.875 12.9105 16.0355 13.75 15 13.75H13.125M6.875 13.75H13.125M6.875 13.75L6.04167 16.25M13.125 13.75L13.9583 16.25M13.9583 16.25L14.375 17.5M13.9583 16.25H6.04167M6.04167 16.25L5.625 17.5M6.25 10L8.75 7.5L10.5397 9.28966C11.3785 8.08584 12.4753 7.07519 13.75 6.33782"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
